/**
 * @module root/index
 * @summary This module exports a Root component that implement client side routing
 */
import React from 'react'
import { Switch, BrowserRouter, Redirect, Route } from 'react-router-dom'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { CssBaseline, MuiThemeProvider } from '@material-ui/core'
import { defaultTheme } from '@zeliot/common/constants/theme'
import MomentUtils from '@date-io/moment'
import { PrivateRoute, PublicRoute } from '@zeliot/common/router'
import DomainConfigError from '@zeliot/common/root/DomainConfigError'
import landingPagesConfig from 'config/whiteLabelLandingPages'
import QueryPages from './AppShell/QueryPages'

// Visual-system review page, never part of a production build
const DesignPreview =
  process.env.NODE_ENV === 'development'
    ? require('@zeliot/core/base/pages/DesignPreview').default
    : null

/**
 * Root component sets up `MuiPickersUtilsProvider` && `CssBaseline` and
 * also sets up React router with public & private routes
 * @param {object} props The react props passed to this component
 * @summary Root component that initialises client side routing
 */
function Root(props) {
  const { customPage, customPageId, page } = props

  let LandingPage

  if (customPage) {
    try {
      LandingPage = landingPagesConfig[customPageId].component
    } catch (e) {
      LandingPage = DomainConfigError
    }
  } else {
    LandingPage = landingPagesConfig.AQUILATRACK.component
  }

  // Public pages and the baseline take the survey-sheet theme; the signed-in
  // app sets its own (light or dark) inside QueryPages
  return (
    <MuiThemeProvider theme={defaultTheme}>
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <CssBaseline />

      <BrowserRouter>
        <Switch>
          <PublicRoute
            exact
            path="/"
            render={() => <LandingPage {...page} />}
          />

          <PrivateRoute path="/home" render={() => <QueryPages />} />

          {DesignPreview && (
            <Route exact path="/design-preview" component={DesignPreview} />
          )}

          <Redirect
            to={{
              pathname: '/'
            }}
          />
        </Switch>
      </BrowserRouter>
    </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  )
}

export default Root
